/* eslint-disable */
import { Col, Row } from "antd";
import { useSelector } from "react-redux";

import { Col_12_8_6_4 } from "../../../components/col/Col_12_8_6_4";
import { LabelValor } from "../../../components/label/LabelValor";
import { ColCampo } from "./ColCampo";
import { Secciones } from "./Secciones";
import { Incidencias } from "./incidencias/Incidencias";



//////////////
export const Datos = () => {
  const {asistencia} = useSelector((state) => state.detalleReducer);
  //////////////
  return (
    <>
      <Row style={{marginBottom: 10}} gutter={[10, 10]}>
        <Col_12_8_6_4>
          <LabelValor label="ID" valor={asistencia.asistenciaID}/>
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Campaña"
            valor={asistencia.asegurado?.campania?.nombre}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Aperturó" valor={asistencia.usuario?.nombre}/>
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Agente" valor={asistencia.agente}/>
        </Col_12_8_6_4>
      </Row>
      <Row style={{marginBottom: 10}} gutter={[10, 10]}>
        <Col_12_8_6_4>
          <LabelValor label="Nombre" valor={asistencia.nombreLlamada}/>
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Apellido paterno"
            valor={asistencia.apellidoPaternoLlamada}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Apellido materno"
            valor={asistencia.apellidoMaternoLlamada}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Teléfono" valor={asistencia.telefono}/>
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Ajustador" valor={asistencia.nombreAjustador}/>
        </Col_12_8_6_4>
      </Row>
      <Row style={{marginBottom: 10}} gutter={[10, 10]}>
        <Col_12_8_6_4>
          <LabelValor
            label="Nombre beneficiario"
            valor={asistencia.nombreBeneficiario}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Apellido paterno"
            valor={asistencia.apellidoPaternoBeneficiario}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Apellido materno"
            valor={asistencia.apellidoMaternoBeneficiario}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Email" valor={asistencia.email}/>
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor label="Tipo de persona" valor={asistencia.tipoPersona}/>
        </Col_12_8_6_4>
      </Row>
      <Row style={{marginBottom: 10}} gutter={[10, 10]}>
        <Col_12_8_6_4>
          <LabelValor
            label="Validador 1"
            valor={asistencia.asegurado.validador1}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Validador 2"
            valor={asistencia.asegurado.validador2}
          />
        </Col_12_8_6_4>
        <Col_12_8_6_4>
          <LabelValor
            label="Vigencia"
            valor={asistencia.asegurado.vigenciaTermino}
          />
        </Col_12_8_6_4>
        <Col xs={24} sm={16} md={12} xl={8}>
          <LabelValor
            label="Servicio"
            valor={`${asistencia.servicio?.tipoAsistencia.nombre} / ${asistencia.servicio?.nombre}`}
          />
        </Col>
      </Row>
      <Row style={{marginBottom: 10}} gutter={[10, 10]}>
        {Object.keys(asistencia)
          .filter((key) => /^campo\d+$/.test(key))
          .sort((a, b) => Number(a.replace("campo", "")) - Number(b.replace("campo", "")))
          .map((key) => (
            <ColCampo key={key} campo={asistencia[key]} />
          ))}
        {asistencia.datosAdicionales && (
          <Col span={24}>
            <LabelValor
              label="Datos adicionales"
              valor={asistencia.datosAdicionales}
            />
          </Col>
        )}
      </Row>
      <Row style={{marginBottom: 10}}>
        <Col span={24}>
          <LabelValor
            label="Direccion origen"
            valor={`${asistencia.direccionOrigen} (${asistencia.municipioOrigen}) | ${asistencia.latOrigen},${asistencia.lngOrigen} `}
          />
        </Col>
      </Row>
      <Row style={{marginBottom: 10}}>
        <Col span={24}>
          {asistencia.latDestino && asistencia.lngDestino && (
            <LabelValor
              label="Direccion destino"
              valor={`${asistencia.direccionDestino} (${asistencia.municipioDestino}) | ${asistencia.latDestino},${asistencia.lngDestino}  `}
            />
          )}
        </Col>
      </Row>
      <Incidencias />
      <Secciones/>
    </>
  );
};
